import { compose, lifecycle } from 'recompose'

import { setWrapDisplayName } from 'hoc/setWrapDisplayName'

export const withComponentWillUnmount = componentWillUnmountFn => BaseComponent =>
  compose(
    setWrapDisplayName(BaseComponent, 'withComponentWillUnmount'),
    lifecycle({
      componentWillUnmount() {
        componentWillUnmountFn(this.props)
      },
    }),
  )(BaseComponent)
